module.exports = __webpack_public_path__ + "img/vertical_4_6_0.e5530100.png";